export default {
  adobeTargetExperience: null,
  userIdTokenizado: null,
  tcode: "",
  isLoading: false,
  trackClickElement: null,
  trackOnClickStart: null,
  // Model del paso 1
  forzarDNE: {},
  socialNet: {
    status: "NONE"
  },
  notificationToast: {
    // [info, success, alert]
    type: "",
    message: ""
  },
  searchEncontesa: {
    searchType: "",
    list: []
  },
  confirmarRenaper: {
    expediente: "",
    yaValido: false
  },
  mock: null,
  openedModal: false,
  consulta: {
    nombre: "",
    apellido: "",
    tipoDoc: "00",
    numeroDoc: "",
    nacionalidad: "80",
    sexo: "",
    email: "",
    tipoResidencia: "",
    fechaNacimiento: "",
    celular: {
      area: "",
      numero: "",
      normalizado: {
        area: "",
        caracteristica: "",
        nro: "",
        interno: "",
        valido: null
      },
      compania: ""
    },
    captcha: ""
  },
  dataOferta: {
    oferta: {
      valid: false
    }
  },
  dataQuery: null,
  paquetesBeneficios: {},
  paso1: {
    estadoCivil: "5",
    conyuge: {
      nombre: "",
      apellido: "",
      tipoDoc: "00",
      numeroDoc: ""
    },
    lugarNacimiento: "",
    domicilioParticular: {
      calle: "",
      numero: "",
      piso: "",
      dpto: "",
      codigoPostal: "",
      localidad: "CAPITAL FEDERAL",
      codProvincia: "01",
      valido: null
    },
    searchEncontesa: false
  },
  paso2: {
    situacionLaboral: "001",
    actividad: "47",
    ocupacion: "07",
    tipoCuil: "49",
    cuil: ""
  },
  paso3: {
    pep: "0",
    sujetoObligado: "0",
    fatca: "0",
    actividadSujetoObligado: ""
  },
  paso4: {
    email: "",
    sucursal: "",
    selectDomicilio: "particular",
    domicilioParticular: {
      calle: "",
      numero: "",
      piso: "",
      dpto: "",
      codigoPostal: "",
      localidad: "",
      codProvincia: "01",
      valido: null
    },
    otroDomicilio: {
      calle: "",
      numero: "",
      piso: "",
      dpto: "",
      codigoPostal: "",
      localidad: "",
      codProvincia: "01",
      valido: null
    },
    searchEncontesa: false
  },
  envioSms: {
    status: "",
    sms: {
      area: "",
      numero: "",
      mensaje: ""
    }
  },
  sucursal: {
    sucursal: "",
    cuil: ""
  },
  graciasCA: {
    cbu: ""
  },
  gracias: {
    cbu: ""
  },
  key: "",
  datosPersonales: {
    estadoCivil: "5",
    conyuge: {
      nombre: "",
      apellido: "",
      tipoDoc: "00",
      numeroDoc: ""
    },
    lugarNacimiento: "",
    domicilioParticular: {
      calle: "",
      numero: "",
      piso: "",
      dpto: "",
      codigoPostal: "",
      localidad: "",
      provincia: "01",
      valido: null
    }
  },
  domicilio: {
    codIden: "",
    claIden: "",
    desDomi: "",
    tDomic: "",
    localid: "CAPITAL FEDERAL",
    codPost: "",
    codProv: "01",
    codPais: "080",
    codNuev: "",
    valNuev: "",
    codModi: "",
    valModi: "",
    tDoModi: "",
    numModi: "",
    accion: "",
    indBloq: "",
    opcion: "",
    coorX: "",
    coorY: "",
    titul: "",
    indDuda: "",
    indOrig: "WEB",
    indPref: "",
    lote: "",
    manzana: "",
    casa: "",
    sector: "",
    parcela: "",
    calle1: "",
    calle2: "",
    tipImb: "",
    dudas: [],
    inusual: false,
    alternativo: false,
    rehacer: false,
    preexistente: false
  },
  domicilioAlternativo: {
    codIden: "",
    claIden: "",
    desDomi: "",
    tDomic: "",
    localid: "CAPITAL FEDERAL",
    codPost: "",
    codProv: "01",
    codPais: "080",
    codNuev: "",
    valNuev: "",
    codModi: "",
    valModi: "",
    tDoModi: "",
    numModi: "",
    accion: "",
    indBloq: "",
    opcion: "",
    coorX: "",
    coorY: "",
    titul: "",
    indDuda: "",
    indOrig: "WEB",
    indPref: "",
    lote: "",
    manzana: "",
    casa: "",
    sector: "",
    parcela: "",
    calle1: "",
    calle2: "",
    tipImb: "",
    dudas: [],
    inusual: false,
    alternativo: false,
    rehacer: false,
    preexistente: false
  },
  datosLaborales: {
    situacionLaboral: "001",
    actividad: "47",
    ocupacion: "07",
    tipoCuil: "49",
    cuil: ""
  },
  informacionAdicional: {
    pep: "0",
    sujetoObligado: "0",
    actividadSujetoObligado: "",
    fatca: "0"
  },
  localidadesAgregadas: {},
  identidad: {
    isDigital: false,
    isPresencial: null,
    isPresencialVoluntario: false
  },
  configuracion: {
    selectDomicilio: "particular",
    sucursal: "",
    domicilioParticular: {
      calle: "",
      numero: "",
      piso: "",
      dpto: "",
      codigoPostal: "",
      localidad: "",
      provincia: "01"
    },
    otroDomicilio: {
      calle: "",
      numero: "",
      piso: "",
      dpto: "",
      codigoPostal: "",
      localidad: "",
      provincia: "01"
    },
    fecha: "",
    hora: "de 9 a 12 hs.",
    resumenDigital: true,
    resumenDigitalEmail: "",
    numeroTramite: ""
  },
  validandoDomicilio: false,
  dataVeridas: {
    key: "",
    response: {
      isValid: null
    },
    contracts: [],
    thanksVeridas: false
  },
  errorVeridas: "",
  error: {},
  sdk: {
    preload: false,
    isVisible: false,
    iframe: null
  },
  dataAuthASO: {
    tsec: "",
    tsecExpiry: null
  },
  DVSIframeData: {
    urlXpressId: "",
    id: ""
  },
  deviceId: "",
  deviceIdTimestamp: "",
  respuestaContratacion: {
    cbu: ""
  },
  contratacionFinalizada: false,
  contrato: {
    firmaContrato: false
  },
  cuenta: false,
  celular: {
    deviceUdid: "",
    otp: "",
    otpValid: null,
    error: false
  },
  usuarioClave: {
    usuario: "",
    claveDigital: ""
  }
};
